<template>
  <div>
    <v-menu offset-y v-model="show" :allow-overflow="true">
      <template v-slot:activator="{ on }">
        <v-text-field
          color="primary"
          v-model="name"
          v-on="on"
          :label="$i18n.t(label)"
          :loading="loading"
          :clearable="clearable"
          :rules="rules"
          @click="onClick"
          @focus="onFocus"
          @blur="onBlur"
          autocomplete="nope"
          :append-outer-icon="hideSearch === '' || hideSearch === true ? '' : 'mdi-magnify' "
          @click:append-outer="dialog = true"
        >Dropdown</v-text-field>
      </template>
      <v-card style="margin: 0;">
        <v-card-text style="padding: 0;">
          <v-list elevation="0" v-if="customers.length > 0 && focus">
            <v-list-item
              v-for="(customer, index) in customers"
              :key="index"
              @click="select(customer)"
              three-line
              dense
              style="border-bottom:1px solid #dfdfdf"
            >
              <v-list-item-title>
                {{ customer.name }}
                <span v-if="customer.email">
                  <br />
                  {{ customer.email }}
                </span>
                <span v-if="customer.phone">
                  <br />
                  +{{ customer.countryCode }} {{ customer.phone }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <!-- <v-card-actions style="padding: 0 0 4px 0;">
        <v-spacer />
        <v-btn small color="blue">
          <v-icon>mdi-magnify</v-icon>Search Advanced
        </v-btn>
        </v-card-actions>-->
      </v-card>
    </v-menu>
    <z-customer-select v-model="dialog" @select="selectCustomer" />
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { doGet } from "@/store/common/module/apis";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CustomerAutofill",
  props: {
    value: {
      default: false
    },
    label: {
      default: "Customer Name"
    },
    clearable: {
      default: false
    },
    email: {
      default: false
    },
    phone: {
      default: false
    },
    hideSearch: {
      default: false
    },
    rules: {
      default: () => []
    }
  },
  mixins: [Themeable, commonMixin]
})
export default class CustomerAutofill extends (Vue, Themeable) {
  customer = { name: null, phone: null, countryCode: null };
  name = null;
  customers = [];
  loading = false;
  show = false;
  focus = false;
  dialog = false;

  mounted() {
    this.onValueChange(this.value);
  }

  select(customer) {
    this.customers = [];
    this.customer = customer;
    if (this.email === "" || this.email) {
      this.name = customer.email;
    } else if (this.phone === "" || this.phone) {
      this.name = customer.phone;
    } else {
      this.name = customer.name;
    }
  }

  clear() {
    this.name = null;
    this.customer = {};
    this.customers = [];
    this.$emit("input", {});
  }

  @Watch("value")
  onValueChange(val) {
    this.customer = val;
    if (this.customer) {
      if (this.email === "" || this.email) {
        this.name = this.customer.email;
      } else if (this.phone === "" || this.phone) {
        this.name = this.customer.phone;
      } else {
        this.name = this.customer.name;
      }
    } else {
      this.name = null;
    }
  }

  @Watch("name")
  async onNameChange(val) {
    if (this.customer == null)
      this.customer = { name: null, phone: null, countryCode: null };
    this.customer.name = val;
    this.$emit("input", this.customer);

    if (val != null && val.length > 2 && val.length < 20) {
      const filter = val.toLowerCase();
      this.loading = true;
      const customers = await doGet("/api/customer/autofill?key=" + filter);
      if (customers != null && customers.length > 0) {
        this.customers = customers;
      } else {
        this.customers = [];
      }
      this.loading = false;
      if (this.customers != null && this.customers.length > 0 && focus)
        this.show = true;
    }
  }

  selectCustomer(customers) {
    this.customer = customers[0];
    this.dialog = false;
    this.$emit("input", this.customer);
  }

  @Watch("customers")
  onCustomerChange(val) {
    if (val == null || val.length == 0) this.show = false;
  }

  onClick() {
    this.onCustomerChange(this.customers);
  }

  onFocus() {
    this.focus = true;
  }

  onBlur() {
    this.focus = false;
  }
}
</script>

<style scoped>
.v-list-item--dense.v-list-item--three-line,
.v-list--dense .v-list-item.v-list-item--three-line {
  min-height: 50px;
}
</style>
